import * as tslib_1 from "tslib";
import { registerHook } from "./core";
// {element: {hookID: callback}}
var useDisconnectedMap = new WeakMap();
/**
 * Purpose: Define a function to be run when the element is disconnected from the DOM
 * Example Usage:
 * ```
 * useDisconnected(() => {
 *   //do something on disconnected
 * });
 * ```
 */
export var useDisconnected = function (cb) {
    var _a = tslib_1.__read(registerHook(), 2), element = _a[0], hookID = _a[1];
    // ensure map exists for this element
    if (!useDisconnectedMap.has(element)) {
        useDisconnectedMap.set(element, new Map());
    }
    // save the callback
    if (!useDisconnectedMap.get(element).has(hookID)) {
        useDisconnectedMap.get(element).set(hookID, cb);
    }
};
// meant to be called by the base element in disconnectedCallback()
export var _callAllUseDisconnectedCallbacks = function (element) {
    if (useDisconnectedMap.has(element)) {
        useDisconnectedMap.get(element).forEach(function (cb) {
            cb();
        });
        useDisconnectedMap.delete(element);
    }
};
//# sourceMappingURL=use-disconnect.js.map